module.exports = "/next-static/_next/static/images/block_image_show_comments-6699336a78c28c92a000697c1939a438.webp";